import React, { useState } from 'react';
import { GoogleMap } from '../components/GoogleMap';
import CompactorMarkers from '../components/CompactorPosition.jsx';
import MapLegend from './../components/MapLegend';
// import VehicleDriverMarker from '../components/VehicleDriverMarker';

const Map = ({
  mapData,
  levelInformation,
  currentOrganisation,
  unClearedAlarms,
  setSelectedColor,
  selectedColor,
}) => {
  let dataLoaded = mapData && currentOrganisation && unClearedAlarms;

  if (dataLoaded) {
    let unClearedAlarmIDs = unClearedAlarms.map((alarm) => alarm.EquipmentID);

    let coordinates = mapData.map((data) => {
      let coordinates = data.coordinates;
      let obj = {};
      obj['EquipmentID'] = data['EquipmentID'];
      obj['FilledLevel'] =
        data['FilledLevel'] < 0 ? 0 : parseInt(data['FilledLevel']);
      obj['Level'] = data['Level'];
      obj['TimeStamp'] = data['TimeStamp'];
      obj['WeightValue'] =
        data['WeightValue'] < 0 ? 0 : parseInt(data['WeightValue']);
      obj['address'] = data['address'];
      obj['lat'] = parseFloat(coordinates['lat']);
      obj['lng'] = parseFloat(coordinates['long']);
      return obj;
    });

    coordinates = coordinates.map((coordinate) => {
      return (
        <CompactorMarkers
          coordinates={{ lat: coordinate['lat'], lng: coordinate['lng'] }}
          markerColor={coordinate['Level']}
          mData={coordinate}
          unClearedAlarms={unClearedAlarms}
        />
      );
    });

    return (
      <div className='App' style={{ height: '70vh' }}>
        <GoogleMap
          apiKey={'AIzaSyBLhVwk04w2-p9ouL1vgRJQoA8nPOegD2Q'}
          mapId={'79015cb6f58c440d'}
          center={{ lat: 1.3552, lng: 103.7972 }}
          zoom={12}
          mapTypeControl={false}
          streetViewControl={false}>
          {coordinates}
          <GoogleMap.Legend controlPosition='LEFT_BOTTOM'>
            <MapLegend
              levelInformation={levelInformation}
              setSelectedColor={setSelectedColor}
              selectedColor={selectedColor}
            />
          </GoogleMap.Legend>
        </GoogleMap>
      </div>
    );
  } else {
    return <div>Loading map....</div>;
  }
  // let mapData = reportData[]
};

export default Map;
